import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import OutstandingCustomerOrders from './OutstandingCustomerOrders';
import { IConfigurationProperties } from './OutstandingCustomerOrders.properties';
import * as api from 'api/dashboardMaintenance/dashboardWidgets/OutstandingCustomerOrders';
import { touch, getFormValues, change } from 'redux-form';
import { IApplicationState } from 'ducks/reducers';

const OUTSTANDING_ORDER_FORM_NAME = 'OutstandingCustomerOrders';
const mapStateToProps = (state: IApplicationState) => ({
    modalFormValues: getFormValues(OUTSTANDING_ORDER_FORM_NAME)(state)
});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        touchFormFields: (...args: any) => touch(OUTSTANDING_ORDER_FORM_NAME, ...args),
        updateFormField: (FieldName: string, FieldValue: any) => change(OUTSTANDING_ORDER_FORM_NAME, FieldName, FieldValue)
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((props: Readonly<Omit<
    IConfigurationProperties, 'getOutstandingCustomerOrders'>>) => {
    return (
        <OutstandingCustomerOrders
            getOutstandingCustomerOrders={api.getOutstandingCustomerOrders}
            {...props} />
    );
});
